export default __webpack_public_path__ + "static/media/GHSI Code of Business Conduct and Ethics.096e9633.pdf";